import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SltIsDuplicateService {

  constructor(private http: HttpClient) { }

  /**
   * Get SLT Duplicate Data from the API
   * @param baseUrl Base URL from GENERAL_CONFIG
   * @param taxYear Tax year from rowData
   * @param leKey LE Key from rowData
   * @param submissionId Submission ID from rowData
   * @param isConsolDupData Flag to determine if consol duplicate data should be included
   * @returns Observable with duplicate data response
   */
  getSltDuplicateData(
    baseUrl: string, 
    taxYear: any, 
    leKey: any, 
    submissionId: any, 
    isConsolDupData: string
  ): Observable<any> {
    const url = `${baseUrl}/getStateGroupDupData?tax_year=${taxYear}&le_key=${leKey}&submission_id=${submissionId}&isConsolDupData=${isConsolDupData}`;
    
    return this.http.get<any>(url, { withCredentials: true });
  }
}
